import { Component } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { CmsUiDynamicContentPage, CmsUiDynamicContentQuery, CmsUiDynamicContentService, PageMeta } from '@lobos/library';
import { Observable } from 'rxjs';
import { first, map, shareReplay, switchMap, tap } from 'rxjs/operators';

@PageMeta<CmsPageComponent>({
  provide: (self: CmsPageComponent) =>
    self.page$.pipe(
      first(),
      map((page: CmsUiDynamicContentPage) => ({ title: page.title, description: page.description })),
    ),
})
@Component({
  selector: 'app-cms-page',
  templateUrl: './cms-page.component.html',
  styleUrls: ['./cms-page.component.scss'],
})
export class CmsPageComponent {
  public page$: Observable<CmsUiDynamicContentPage>;

  private id: number | any;

  constructor(
    protected route: ActivatedRoute,
    protected cmsService: CmsUiDynamicContentService,
    protected cmsQuery: CmsUiDynamicContentQuery,
  ) {
    this.page$ = this.route.paramMap.pipe(
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      map((param: ParamMap) => +param.get('id')!),
      tap((id: number) => (this.id = id)),
      switchMap(() => this.cmsService.getCMSPage(this.id)),
      switchMap(() => this.cmsQuery.page(this.id)),
      shareReplay(1),
    );
  }
}
